module.exports = __webpack_public_path__ + "static/offsetpanel2-e978d36518ac4ea630f4b5e44e8a119f.png";